import React, { useState } from 'react';

import RoleDropdown from '../../../../UsersList/CreateSuperAdminModal/RoleDropDown';
import { ORGANIZATION, ROLE_DESCRIPTION } from '../../../../../enums';
import { ContainedButton, OutlinedButton } from '../../../Buttons';
import { useAppSelector } from '../../../../../store/hooks';
import styles from './AppendOrgModal.module.scss';
import Search from '../../../Search';
import Modal from '../../../Modal';

type TAppendOrgModal = {
  onSelect: (data: { orgId: string; role?: ROLE_DESCRIPTION; organization: ORGANIZATION }) => void;
  switchModal: () => void;
  orgList: ORGANIZATION[];
  selectedOrgs: { orgId: string; role: ROLE_DESCRIPTION }[];
  open: boolean;
  cancelSelection: () => void;
};

const AppendOrgModal: React.FC<TAppendOrgModal> = ({ open, switchModal, orgList, onSelect, selectedOrgs, cancelSelection }) => {
  const [searchOrgText, setSearchOrgText] = useState('');
  const { allRoles } = useAppSelector((state) => state.user);
  const onOrgSelect = (orgId: string, organization: ORGANIZATION) => {
    onSelect({ orgId, organization });
  };

  return (
    <Modal open={open} onClose={switchModal}>
      <div className={styles.modalBody}>
        <div className={styles.orgForm}>
          <div className={styles.orgHeading}> Select Organisation </div>
          <Search className={styles.searchOrg} onChange={(e) => setSearchOrgText(e.target.value)} placeHolder="Search by Name" />

          <div className={styles.orgList} id="org_list">
            {orgList
              .filter((org) => org.name.toLocaleLowerCase().includes(searchOrgText.toLocaleLowerCase()))
              .map((org) => (
                <div key={org.id} className={styles.org} onClick={() => onOrgSelect(org.id, org)}>
                  <div className={styles.orgTitle}>{org.name}</div>
                  <div className={styles.orgRight}>
                    <RoleDropdown
                      onSelect={(role: string) =>
                        onSelect({
                          orgId: org.id,
                          role: allRoles.find((r) => r.title === role),
                          organization: org,
                        })
                      }
                      disabled={!selectedOrgs.find((obj) => obj.orgId === org.id)}
                      selectedRole={selectedOrgs.find((obj) => obj.orgId === org.id)?.role.title}
                    />
                    <input className={styles.orgCheck} checked={!!selectedOrgs.find((obj) => obj.orgId === org.id)} type="checkbox" />
                  </div>
                </div>
              ))}
          </div>

          <div className={styles.customPadding}>
            <div className={styles.actionBtns}>
              <ContainedButton onClick={switchModal}>Save</ContainedButton>
              <OutlinedButton onClick={cancelSelection}>Cancel</OutlinedButton>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AppendOrgModal;
